export class QuartoFailure {
    static MUST_GIVE_A_PIECE = () => $localize `You must give a piece.`;
    static PIECE_ALREADY_ON_BOARD = () => $localize `That piece is already on the board.`;
    static CANNOT_GIVE_PIECE_IN_HAND = () => $localize `You cannot give the piece that was in your hands.`;
}
